import React from 'react';
import { CImage } from '@app/components/Common';
import { Text, View } from '@/styles/reactnative';

const ListCoin = ({ item }) => {
  const pairParts = item?.pairs?.split('/') || [];
  const baseCoin = pairParts[0] || '';
  const quoteCoin = pairParts[1] || '';

  return (
    <View
      style={{
        flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flexDirection: 'row',
      }}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <CImage
          src={item?.image}
          alt="logo"
          width={24}
          height={24}
          resizeMode={'cover'}
          style={{ borderRadius: 50 }}
        />
        <View style={{ flexDirection: 'column', marginLeft: 8, alignItems: 'flex-start' }}>
          <View style={{ flexDirection: 'row', alignItems: 'baseline' }}>
            <Text
              style={{
                fontWeight: 700,
                fontSize: 14,
                letterSpacing: -0.2,
              }}
            >
              {baseCoin}
            </Text>
            <Text
              style={{
                fontWeight: 500,
                fontSize: 12,
                marginLeft: 2,
                opacity: 0.6,
              }}
            >
              /{quoteCoin}
            </Text>
          </View>
          <Text
            style={{
              fontSize: 11,
              fontWeight: 400,
              opacity: 0.5,
              marginTop: 2,
              textAlign: 'left',
            }}
          >
            USDT Perpetual
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ListCoin;
